import { koComponent } from '../../../ko-utils/index';
import * as siteConfig from '../../../site-config/config';
import createUuid from '../../../utils/uuid';
import tryMakeUrlDynamic from '../../../utils/tryMakeUrlDynamic';

class ButtonWidget {
    constructor(params, parent) {
        this.widget = ko.unwrap(params.widget);
        this.parent = parent;

        if (!this.widget.type()) {
            this.widget.type('blanklink');
        }

        this.types = [
            { value: 'blanklink', text: 'Link (new tab)' },
            { value: 'link', text: 'Link' }
        ];

        this.dataType = ko.computed(() => {
            const widgetType = this.widget.type();

            if (widgetType === 'link' || widgetType === 'blanklink') {
                return 'namedUrl';
            }
        });
    }
}


export default koComponent('button-widget', ButtonWidget);